import { FaShieldAlt, FaVideo, FaBell, FaLock, FaCloud, FaMobile, FaLightbulb, FaUserShield, FaBuilding, FaNetworkWired, FaChartLine } from 'react-icons/fa';
import images from './images';

const systemFeatures = {
    sub: "Advanced Technology",
    heading: "System Features",
    tabs: [
        {
            id: "residential",
            title: "Residential",
            image: images.residential1,
            alt: "Residential Security System",
            heading: "Reliable Residential Security Solutions",
            description: "Ensure the safety of your home and loved ones with our state-of-the-art residential security systems. We provide smart solutions to keep your space protected 24/7.",
            features: [
                { icon: <FaVideo />, title: "HD CCTV Cameras" },
                { icon: <FaBell />, title: "Smart Alarm Systems" },
                { icon: <FaLock />, title: "Access Control Systems" },
                { icon: <FaShieldAlt />, title: "24/7 Monitoring" },
                { icon: <FaCloud />, title: "Remote Access via Cloud" },
                { icon: <FaMobile />, title: "Mobile App Integration" },
                { icon: <FaLightbulb />, title: "Motion Detection Sensors" },
                { icon: <FaUserShield />, title: "Professional Consultation" }
            ]
        },
        {
            id: "commercial",
            title: "Commercial",
            image: images.commercial1,
            alt: "Commercial Security System",
            heading: "Comprehensive Security for Your Business",
            description: "Protect your commercial spaces with advanced security systems tailored to your business needs. From CCTV surveillance to access control, we ensure your business stays secure 24/7.",
            features: [
                { icon: <FaVideo />, title: "High-Definition Surveillance" },
                { icon: <FaBuilding />, title: "Enterprise Alarm Systems" },
                { icon: <FaLock />, title: "Smart Access Controls" },
                { icon: <FaNetworkWired />, title: "Integrated System" },
                { icon: <FaCloud />, title: "Cloud-Based Monitoring" },
                { icon: <FaMobile />, title: "Mobile App Connectivity" },
                { icon: <FaChartLine />, title: "Real-Time Analytics" },
                { icon: <FaUserShield />, title: "Customizable Plans" }
            ]
        }
    ],
    icons: {
        shield: <FaShieldAlt />
    }
};

export default systemFeatures;